<template>
    <div id="modal1" class="modal modal-scoped">
        <div class="modal-content">
            <h4 >{{ state.titulo }}</h4>
            <p> {{ state.mensagem }}</p>
            <input id="senhaModal" v-show="state.inputvisible" autofocus type="password" @keyup.enter="ok()" v-model="senha" onfocus="value=''" >
        </div>
        <div class="modal-footer">
            <button id="closeModal" class="waves-effect waves-green btn" @click="ok()" v-show="state.btnokvisible" >Ok</button>
        </div>
    </div>
</template>

<script>

export default {
  name: 'modal-component',
  data () {
    return {
      titulo: '',
      mensagem: '',
      tipo: '',
      senha: '',
      inputvisible: true,
      btnokvisible: false
    }
  },
  mounted () {
  },
  methods: {
    ok: function () {
      this.$data.tipo = this.state.tipo
      let data = JSON.parse(JSON.stringify(this.$data))
      this.$store.commit('OK_CLICK_MODAL', data, this)
    }
  },
  computed: {
    state: function () {
      return this.$store.state.Modal
    }
  }
}
</script>

<style scoped>

.modal-scoped {
    top: 25% !important
}

</style>



// WEBPACK FOOTER //
// jm-modal.vue?175e8833